export const Z_BUILDER_SHELL = 1050;
export const Z_BUILDER_NESTED_MODAL = Z_BUILDER_SHELL + 100;
export const Z_BUILDER_MUI_PORTALS = Z_BUILDER_SHELL + 500;
export const Z_BUILDER_DIALOG_ABOVE_APP_NAV = 10050;
export const Z_BUILDER_DIALOG_MENU_THEME_MODAL = Z_BUILDER_DIALOG_ABOVE_APP_NAV + 150;
export const Z_BUILDER_RESOURCE_TYPE_SELECTOR_MODAL = Z_BUILDER_DIALOG_ABOVE_APP_NAV + 400;
